import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SelectPageRoutingModule } from './select-routing.module';

import { SelectPage } from './select.page';
import {PickListModule} from 'primeng/picklist';

import { PipesModule } from 'src/app/pipes/pipes.module';
import { DropdownModule } from 'primeng/dropdown';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SelectPageRoutingModule,
    PickListModule,
    PipesModule,
    DropdownModule
  ],
  declarations: [SelectPage]
})
export class SelectPageModule {}
